import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Root';
import moment from 'moment'

import './scss/bootstrap.css'
import './scss/main.css'

ReactDOM.render(<Root />, document.getElementById('root'));

if (module.hot) {
  module.hot.accept('./Root', () => {
    ReactDOM.render(<Root />, document.getElementById('root'))
  })
}


// WEBPACK FOOTER //
// ./src/index.js